import { createSlice } from "@reduxjs/toolkit";
const authSlice = createSlice(
    {
        name: 'admin',
        initialState: {
            admin: null,
            deviceId: null
        },
        reducers: {
            addAmin: (state, action) => {
                state.admin = action.payload;
            },
            AddDeviceId:(state,action)=>{
                // console.log(action.payload,"action.payload");
                state.deviceId = action.payload
            }
        }
    }
)

export const selectAdmin = (state) => state.admin.admin;
export const selectDevice = (state) => state.admin.deviceId;

export const { addAmin ,AddDeviceId} = authSlice.actions
export default authSlice.reducer;